module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lacerta/lac_gal-ffec9190ef128f7ab8ee6022435d3a42.gif";